import { Box, Card, BoxProps, CardProps } from '@mantine/core';
import cn from 'clsx';

export function ContentCard({
  children,
  wrapperProps,
  cardProps,
}: {
  children: React.ReactNode;
  wrapperProps?: BoxProps;
  cardProps?: CardProps;
}) {
  return (
    <Box w={544} mx="auto" className="relative max-w-full" {...wrapperProps}>
      <Card
        {...cardProps}
        className={cn('z-10 py-4 px-6 lg:py-6 lg:px-12', cardProps?.className)}
      >
        {children}
      </Card>

      <div
        className={cn(
          'absolute left-[40px] top-[60px]',
          'w-[calc(100%-80px)] h-[calc(100%-120px)]',
          'bg-[radial-gradient(ellipse_at_center,#B94DFF_0%,#B94DFF_10%,transparent_100%)] blur-[100px]'
        )}
      />
    </Box>
  );
}
